import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import {
  AgreementType,
  IAgreementContentBlock,
} from '../../../redux/api/agreements/interfaces';
import { useStyles } from './AgreementsContent.styles';
import AgreementsLeadBlock from './AgreementsLeadBlock';
import AgreementsRegularBlocks from './AgreementsRegularBlocks';
import { splitAgreementLeadBlocks } from './splitAgreementLeadBlocks';

interface IAgreementsContentProps {
  blocks: IAgreementContentBlock[];
  agreementType: AgreementType;
  headerClose?: () => void;
}

const AgreementsContent = ({
  blocks,
  agreementType,
  headerClose,
}: IAgreementsContentProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { beforeLead, leadTitle, leadParagraph, afterLead } =
    splitAgreementLeadBlocks(blocks);

  const headerCloseButton =
    headerClose != null ? (
      <IconButton
        aria-label={t('common.close')}
        onClick={headerClose}
        edge="end"
        size="small"
        sx={{ color: 'text.secondary' }}>
        <CloseIcon />
      </IconButton>
    ) : null;

  return (
    <div className={classes.root}>
      {!leadTitle && headerCloseButton ? (
        <div className={classes.closeOnlyRow}>{headerCloseButton}</div>
      ) : null}
      <AgreementsRegularBlocks blocks={beforeLead} keyPrefix="before" />
      {leadTitle ? (
        <AgreementsLeadBlock
          title={leadTitle.value}
          paragraph={leadParagraph?.value}
          agreementType={agreementType}
          titleEndAdornment={headerCloseButton}
        />
      ) : null}
      <AgreementsRegularBlocks blocks={afterLead} keyPrefix="after" />
    </div>
  );
};

export default AgreementsContent;
